import { useEffect, useState, useCallback } from 'react';
import AppHeader from '../../components/AppHeader';
import { useAuth } from '../../contexts/MemberAuthContext';
import { writeoffsApi, chaptersApi, WRITEOFF_REASONS } from '../../api';

export default function Writeoffs() {
  const { member } = useAuth();
  const needsPick = !member.chapter_id;
  const [chapters, setChapters] = useState([]);
  const [chapterId, setChapterId] = useState(member.chapter_id || '');
  const [rows, setRows] = useState([]);

  useEffect(() => { if (needsPick) chaptersApi.list().then((r) => setChapters(r.data)).catch(() => {}); }, [needsPick]);

  const load = useCallback(() => {
    if (!chapterId) { setRows([]); return; }
    writeoffsApi.list(chapterId).then((r) => setRows(r.data)).catch(() => setRows([]));
  }, [chapterId]);
  useEffect(() => { load(); }, [load]);

  const fmt = (d) => d ? new Date(d).toLocaleString('cs-CZ', { day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit' }) : '';

  return (
    <div>
      <AppHeader subtitle="Odpisy materiálu" />
      <div className="container-wide" style={{ paddingTop: 24 }}>
        <p className="text-muted mb-16">Spotřebovaný, poškozený, ztracený nebo darovaný materiál zapsaný při vyúčtování cest.</p>

        {needsPick && (
          <div className="form-group">
            <label>Oblastní spolek</label>
            <select className="form-input" value={chapterId} onChange={(e) => setChapterId(e.target.value)}>
              <option value="">— vyberte spolek —</option>
              {chapters.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
            </select>
          </div>
        )}

        {chapterId && (
          <div className="flex" style={{ justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
            <h3>Odpisy ({rows.length})</h3>
            {rows.length > 0 && <a className="btn btn-outline btn-sm" href={writeoffsApi.csvUrl(chapterId)} download>⬇ CSV</a>}
          </div>
        )}

        <div className="table-wrapper">
          <table>
            <thead><tr><th>Datum</th><th>Položka</th><th>Množství</th><th>Důvod</th><th>Zdroj</th><th>MU</th><th>Kdo</th></tr></thead>
            <tbody>
              {rows.map((w) => (
                <tr key={w.id}>
                  <td className="text-muted" style={{ fontSize: '0.85rem', whiteSpace: 'nowrap' }}>{fmt(w.created_at)}</td>
                  <td>{w.item_name}</td>
                  <td style={{ whiteSpace: 'nowrap' }}>{w.quantity} {w.unit}</td>
                  <td><span className="badge badge-out">{WRITEOFF_REASONS[w.reason] || w.reason}</span></td>
                  <td className="text-muted" style={{ fontSize: '0.85rem' }}>{w.source || ''}</td>
                  <td className="text-muted" style={{ fontSize: '0.85rem' }}>{w.event_name || ''}</td>
                  <td className="text-muted" style={{ fontSize: '0.85rem' }}>{(w.by_first_name || w.by_last_name) ? `${w.by_first_name || ''} ${w.by_last_name || ''}`.trim() : ''}</td>
                </tr>
              ))}
              {chapterId && rows.length === 0 && <tr><td colSpan={7} className="text-muted text-center">Zatím žádné odpisy.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
